import React from "react";
import { useTheme } from "../contexto/ThemeProvider";
import { Sun, Moon } from "./Icons";

function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      aria-label={isDark ? "Ativar tema claro" : "Ativar tema escuro"}
      title={isDark ? "Tema claro" : "Tema escuro"}
    >
      <span className="knob">{isDark ? <Moon /> : <Sun />}</span>
    </button>
  );
}

export default ThemeToggle;
